import React, { useEffect, useState, useRef } from "react";
import { Card, Modal, Nav, Tab } from "react-bootstrap";
import OTPInput from "react-otp-input";
import MainPagetitle from "../../../layouts/MainPagetitle";
import TransactionTable from "./TransactionTable";

const kyc = (props) => {
  const [showPanModal, setShowPanModal] = useState(false);
  const [pandetails, setPandetails] = useState(null);
  const [showPanDetails, setShowPanDetails] = useState(false);
  const [showAadharModal, setShowAadharModal] = useState(false);
  const [showotpinput, setShowotpinput] = useState(false);
  const [otpValue, setOtpValue] = useState("");
  const [aadhaarOtpResponse, setAadhaarOtpResponse] = useState(null);
  const [aadharinfo, setAadharinfo] = useState(null);
  const [showaadharinfo, setShowaadharinfo] = useState(false);
  const [isOtpDisabled, setIsOtpDisabled] = useState(true);
  const [isAadharDisabled, setIsAadharDisabled] = useState(true);
  //
  const [errorMessage, setErrorMessage] = useState({ name: "", message: "" });

  const digiLockerWindowRef = useRef(null);

  useEffect(() => {
    const handleMessage = (event) => {
      if (event.data === "digilocker_complete") {
        const requestId = sessionStorage.getItem("vas_aadhaar_request_id");
        if (requestId) {
          let payload = {
            requestId: requestId,
          };
          props.apis.apiGetDigilockerCheckUsingRequestId(payload).then((response) => {
            let info = response?.result || response?.data || response;
            setAadharinfo(info);
            setShowaadharinfo(true);
            setIsAadharDisabled(false);
          });
        }

        if (
          digiLockerWindowRef.current &&
          !digiLockerWindowRef.current.closed
        ) {
          digiLockerWindowRef.current.close();
        }
      }
    };

    window.addEventListener("message", handleMessage);
    return () => window.removeEventListener("message", handleMessage);
  }, []);

  // RECHARGE MODAL
  const [showrechargemodal, setShowrechargemodal] = useState(false);
  const [showCustomAmountInput, setShowCustomAmountInput] = useState(false);
  const [userbalance, setUserbalance] = useState(null);
  const [balanceData, setBalanceData] = useState(null);

  // TRANSACTION MODAL
  const [showtransmodal, setShowtransmodal] = useState(false);
  const [activeKey, setActiveKey] = useState("this-month");
  const tabData = [
    {
      key: "this-month",
      name: "This Month",
      content: <TransactionTable />,
    },
    {
      key: "last-three-months",
      name: "Last 3 Months",
      content: <TransactionTable />,
    },
    {
      key: "last-six-months",
      name: "Last 6 Months",
      content: <TransactionTable />,
    },
    {
      key: "custom",
      name: "Custom",
      content: <TransactionTable />,
    },
  ];

  // ----------------------------------------------------------------

  const handleSelect = (key) => {
    setActiveKey(key);
  };

  const handleKycList = (item) => {
    console.log({ item });
    if (item.type === "modal") {
      openModal(item?.modalname);
    }
    if (item.linkname === "creditscore") {
      navigate("/app/creditscore");
    }
    if (item.linkname === "bsa") {
      navigate("/app/bankstatementanalyzer");
    }
    if (item.linkname === "servicevendorrecords") {
      navigate("/app/servicevendorrecords");
    }
  };

  const kyclists = [
    {
      title: "PAN Verification",
      charges: 5,
      image: imagepaths.PANplaceholderImg,
      type: "modal",
      modalname: "pan",
    },
    {
      title: "Aadhar Verification",
      charges: 5,
      image: imagepaths.AadharplaceholderImg,
      type: "modal",
      modalname: "aadhar",
    },
    {
      title: "Credit Score",
      charges: 5,
      image: imagepaths.creditplaceholderImg,
      type: "link",
      linkname: "creditscore",
      modalname: "credit-score",
    },
    {
      title: "BSA",
      charges: 5,
      image: imagepaths.bsaImg,
      type: "link",
      linkname: "bsa",
      modalname: "bsa",
    },
    // {
    //   title: "Service Vendor Records",
    //   image: imagepaths.creditplaceholderImg,
    //   type: "link",
    //   linkname: "servicevendorrecords",
    //   className_body: "centered-title",
    // },
  ];

  const openModal = (modalname) => {
    if (modalname === "pan") {
      setShowPanModal(true);
    }
    if (modalname === "aadhar") {
      setShowAadharModal(true);
    }
  };

  const closePanModal = () => {
    setShowPanModal(false);
    setShowPanDetails(false);
  };

  const closeAadharModal = () => {
    setShowAadharModal(false);
    setShowotpinput(false);
    setOtpValue("");
    setAadhaarOtpResponse(null);
    setIsAadharDisabled(true);
    setShowaadharinfo(false);
    setAadharinfo(null);
  };

  const handlePanVerify = (e, data) => {
    e.preventDefault();
    e.stopPropagation();
    let payload = {
      pan: data.pan,
    };
    props.apis.apiGetKycPanDetails(payload).then((res) => {
      console.log({ res });
      setPandetails(res);
      setShowPanDetails(true);
    });
  };

  const handlePanSubmit = (e) => {
    e.preventDefault();
    e.stopPropagation();
    closePanModal();
    setShowPanDetails(false);
  };

  // AADHAR
  const handleAadharVerify = (e) => {
    e?.preventDefault?.();
    e?.stopPropagation?.();
    let payload = {
      callbackUrl: window.location.origin + "/open/digilockercallback",
    };
    props.apis.apiGetKYCDigilockerUrlForUserConsent(payload).then((response) => {
      let requestId = response?.requestId || response?.result?.requestId;
      let url = response?.url || response?.result?.url;
      
      if (requestId) {
        sessionStorage.setItem("vas_aadhaar_request_id", requestId);
      }
      if (url) {
        digiLockerWindowRef.current = window.open(
          url,
          "DigiLockerTab",
          "width=1200,height=800"
        );
      }
    });
  };

  const handleOTPChange = (otp) => {
    // setOTP(otp);
    setOtpValue(otp);
    if (otp.length === 6) {
      setIsOtpDisabled(false);
    } else {
      setIsOtpDisabled(true);
    }
  };

  const handleOtpVerify = (e) => {
    let payload = {};
    if (
      aadhaarOtpResponse.hasOwnProperty("referenceId") ||
      aadhaarOtpResponse.hasOwnProperty("transactionId")
    ) {
      payload = {
        reference_id: aadhaarOtpResponse?.referenceId,
        transaction_id: aadhaarOtpResponse?.transactionId,
        otp: otpValue,
      };
    } else {
      payload = {
        requestId: aadhaarOtpResponse?.requestId,
        otp: otpValue,
      };
    }
    props.apis.apiGetKycAadharDetails(payload).then((res) => {
      console.log({ res });
      setAadharinfo(res);
      setShowaadharinfo(true);
      setIsAadharDisabled(false);
    });
  };

  const resendOTP = () => {};

  const handleAadharSubmit = (e) => {
    closeAadharModal();
  };

  // RECHARGE MODAL
  const closeRechargeModal = () => {
    setShowrechargemodal(false);
  };

  const handleRechargeAmount = (e) => {
    let key = e[0].key;
    if (key === "others") {
      setShowCustomAmountInput(true);
    } else {
      setShowCustomAmountInput(false);
    }
  };

  const handleRechargeSubmit = (e, data) => {
    e.preventDefault();
    let obj = {
      ...data,
    };
    let payload = {
      profileId: props?.$store?.user?.profileId,
      ...Object.only(obj, ["amount"]),
    };

    if (data?.amount === "others") {
      payload.amount = Number(data.custom_amount);
    } else {
      payload.amount = Number(data.amount);
    }

    // props.apis.apiVasRecharge(payload).then((res) => {
    //   closeRechargeModal();
    //   setBalanceData();
    // });
  };

  // TRANSACTION MODAL
  const closeTransModal = () => {
    setShowtransmodal(false);
  };

  const getUserBalance = () => {
    props.apis.apiAdminGetWalletBalance().then((res) => {
      console.log({ res });
      let balanceAmt = res?.Data?.FundsAvailableResult?.BalanceAmount;
      setBalanceData(balanceAmt);
    });
  };

  const getBackLink = () => {
    return "/app/kyc";
  };

  // useEffect(() => {
  //   getUserBalance();
  // }, []);

  props.$setNode({
    props,
    errorMessage,
  });
  return (
    <>
      <MainPagetitle
        mainTitle="Know Your Customer"
        backLink={getBackLink()}
        pageIcon={imagepaths.PersonSearchIconActive}
      />
      <div className="container-fluid">
        <div className="kyc_container">
          {/* <h2 className="heading-title">Know Your Customer</h2> */}
          {
            false &&
            <div className="row g-4">
              <div className="col-12 col-md-12 col-lg-6">
                <div className="metrics_card">
                  <div className="col_left">
                    <img src={imagepaths.walletWhiteIcon} alt="card icon" />
                  </div>
                  <div className="col_right">
                    {/* <h5 className="card-title">
                    Rs.
                    <div className="amount_box">
                      {balanceData?.cur() || "-"}
                    </div>
                  </h5>
                  <div className="bottom_content">
                    <p className="card-text">
                      <span>Balance</span>
                    </p>
                  </div> */}
                  </div>
                  <button
                    type="button"
                    className="btn white_btn ms-3"
                    onClick={() => setShowrechargemodal(true)}
                  >
                    Recharge Your Wallet
                  </button>
                </div>
              </div>
              <div className="col-12 col-md-12 col-lg-6">
                <div className="metrics_card">
                  <div className="col_left">
                    <img src={imagepaths.transactionWhiteIcon} alt="card icon" />
                  </div>
                  <div className="col_right">
                    <h5 className="card-title">Transactions</h5>
                    <div className="bottom_content">
                      <p className="card-text">
                        <span>Details</span>
                      </p>
                    </div>
                  </div>
                  <button
                    type="button"
                    className="btn white_btn ms-3"
                    onClick={() => setShowtransmodal(true)}
                  >
                    View Details
                  </button>
                </div>
              </div>
            </div>
          }
          <div className="row g-3">
            {kyclists?.map((item, i) => {
              return (
                <div
                  className="col-12 col-sm-6 col-md-6 col-lg-4 col-xl-3"
                  key={i}
                >
                  <div
                    className="offline_card"
                    onClick={() => handleKycList(item)}
                  >
                    <div className={`body d-flex align-items-center ${item?.className_body}`}>
                      <img
                        src={item.image}
                        className="img-fluid me-3"
                        alt={item.title}
                      />
                      <div>
                        <h4 className="title d-flex align-items-center">
                          {item.title}
                        </h4>
                        {/* {item.charges && (
                          <p className="m-0">Charge: Rs. {item.charges}</p>
                        )} */}
                      </div>
                    </div>
                  </div>
                </div>
              );
            })}
          </div>
        </div>
      </div>

      {/* PAN MODAL */}
      <Modal
        show={showPanModal}
        onHide={closePanModal}
        centered
        backdrop="static"
        className="consent_otp_modal"
      >
        <Modal.Header
          closeButton
          className="border-0 py-4 d-flex align-item-start"
        >
          <h2>PAN Verification</h2>
        </Modal.Header>
        <Modal.Body className="pt-0">
          <div className="row g-3 mb-4">
            {!showPanDetails ? (
              <AppForm onSubmit={handlePanVerify}>
                <AppInput type="text" name="pan" label="Enter PAN No." />
                <div className="col-12">
                  <button
                    type="submit"
                    className="btn btn-primary w-100 py-3 mb-3"
                  >
                    Verify
                  </button>
                  <button
                    type="button"
                    className="btn text-primary w-100 py-3"
                    onClick={(e) => closePanModal()}
                  >
                    Cancel
                  </button>
                </div>
              </AppForm>
            ) : (
              <div class="profile_details_container">
                
                <div className="row">
                  <div className="col-md-12">
                    <div className="profile_detail mb-3 p-3 rounded border-detail">
                      <p className="m-0 text-muted">Name as per PAN</p>
                      <h4 className="mb-0 mt-1">{pandetails?.name || "-"}</h4>
                    </div>
                  </div>
                  <div className="col-md-6 col-lg-4">
                    <div className="profile_detail mb-3">
                      <p className="m-0 text-muted">PAN Number</p>
                      <h5 className="mb-0 mt-1">{pandetails?.number || "-"}</h5>
                    </div>
                  </div>
                  <div className="col-md-6 col-lg-4">
                    <div className="profile_detail mb-3">
                      <p className="m-0 text-muted">Type of Holder</p>
                      <h5 className="mb-0 mt-1">{pandetails?.typeOfHolder || "-"}</h5>
                    </div>
                  </div>
                  <div className="col-md-6 col-lg-4">
                    <div className="profile_detail mb-3">
                      <p className="m-0 text-muted">First Name</p>
                      <h5 className="mb-0 mt-1">{pandetails?.firstName || "-"}</h5>
                    </div>
                  </div>
                  <div className="col-md-6 col-lg-4">
                    <div className="profile_detail mb-3">
                      <p className="m-0 text-muted">Last Name</p>
                      <h5 className="mb-0 mt-1">{pandetails?.lastName || "-"}</h5>
                    </div>
                  </div>
                  <div className="col-md-6 col-lg-4">
                    <div className="profile_detail mb-3">
                      <p className="m-0 text-muted">PAN Status</p>
                      <h5 className="mb-0 mt-1" style={{ color: pandetails?.panStatus === "VALID" ? "#198754" : "#dc3545"}}>
                        {pandetails?.panStatus || "-"}
                      </h5>
                    </div>
                  </div>
                  <div className="col-md-6 col-lg-4">
                    <div className="profile_detail mb-3">
                      <p className="m-0 text-muted">Aadhaar Seeding</p>
                      <h5 className="mb-0 mt-1" style={{ color: pandetails?.aadhaarSeedingStatus === "Successful" ? "#198754" : "#fd7e14"}}>
                        {pandetails?.aadhaarSeedingStatus || "-"}
                      </h5>
                    </div>
                  </div>
                  <div className="col-md-6 col-lg-4">
                    <div className="profile_detail mb-3">
                      <p className="m-0 text-muted">Middle Name</p>
                      <h5 className="mb-0 mt-1" >{pandetails?.middleName || "-"}</h5>
                    </div>
                  </div>
                  <div className="col-md-6 col-lg-4">
                    <div className="profile_detail mb-3">
                      <p className="m-0 text-muted">Title</p>
                      <h5 className="mb-0 mt-1" >{pandetails?.title || "-"}</h5>
                    </div>
                  </div>
                  <div className="col-md-6 col-lg-4">
                    <div className="profile_detail mb-3">
                      <p className="m-0 text-muted" >Is Individual</p>
                      <h5 className="mb-0 mt-1" >{pandetails?.isIndividual ? "Yes" : "No"}</h5>
                    </div>
                  </div>
                  <div className="col-md-6 col-lg-4">
                    <div className="profile_detail mb-3">
                      <p className="m-0 text-muted" >Is Valid</p>
                      <h5 className="mb-0 mt-1" style={{ color: pandetails?.isValid ? "#198754" : "#dc3545" }}>{pandetails?.isValid ? "Yes" : "No"}</h5>
                    </div>
                  </div>
                  <div className="col-md-6 col-lg-4">
                    <div className="profile_detail mb-3">
                      <p className="m-0 text-muted" >PAN Status Code</p>
                      <h5 className="mb-0 mt-1" >{pandetails?.panStatusCode || "-"}</h5>
                    </div>
                  </div>
                  <div className="col-md-6 col-lg-4">
                    <div className="profile_detail mb-3">
                      <p className="m-0 text-muted" >Aadhaar Seeding Code</p>
                      <h5 className="mb-0 mt-1" >{pandetails?.aadhaarSeedingStatusCode || "-"}</h5>
                    </div>
                  </div>
                  <div className="col-md-12">
                    <div className="profile_detail mb-3">
                      <p className="m-0 text-muted" >Last Updated On</p>
                      <h5 className="mb-0 mt-1" >{pandetails?.lastUpdatedOn || "-"}</h5>
                    </div>
                  </div>
                </div>
                {/* <div class="profile_detail mb-3">
                  <p class="m-0">Date of birth as per PAN</p>
                  <h4>{pandetails?.dob || "-"}</h4>
                </div> */}
                <div className="col-12">
                  <button
                    type="submit"
                    className="btn btn-primary w-100 py-3 mb-3"
                    onClick={(...args) => handlePanSubmit(...args)}
                  >
                    Submit
                  </button>
                  <button
                    type="button"
                    className="btn text-primary w-100 py-3"
                    onClick={(e) => closePanModal()}
                  >
                    Cancel
                  </button>
                </div>
              </div>
            )}
          </div>
        </Modal.Body>
      </Modal>

      {/* AADHAR MODAL */}
      <Modal
        show={showAadharModal}
        onHide={closeAadharModal}
        centered
        backdrop="static"
        className="consent_otp_modal"
      >
        <Modal.Header
          closeButton
          className="border-0 py-4 d-flex align-item-start"
        >
          <h2>Aadhar Verification</h2>
        </Modal.Header>
        <Modal.Body className="pt-0">
          <div className="row g-3 mb-4">
            {!showaadharinfo ? (
              <>
                <div className="col-12 mb-3">
                  <h4 className="mb-3">Instruction to follow:</h4>
                  <ul className="aadhar_instruction_ul">
                    <li>
                      Click on the below <strong>Login to Digilocker</strong> button.
                    </li>
                    <li>
                      It will take you a new tab to enter your 12 digit Aadhar card
                      number.
                    </li>
                    <li>
                      Click <strong>Next</strong> and provide the OTP from the Aadhar card
                      owner's phone.
                    </li>
                    <li>
                      After clicking <strong>Continue</strong> button, accept{" "}
                      <strong>Signzy</strong> access to <strong>DigiLocker</strong> by clicking
                      on Allow button.
                    </li>
                  </ul>
                </div>
                <div className="col-12 d-flex flex-column">
                  <button
                    type="button"
                    className="btn btn-primary w-100 py-3 mb-3"
                    onClick={(e) => handleAadharVerify(e)}
                  >
                    Login to Digilocker
                  </button>
                  <button
                    type="button"
                    className="btn text-primary w-100 py-3"
                    onClick={(e) => closeAadharModal()}
                  >
                    Cancel
                  </button>
                </div>
              </>
            ) : (
              <>
                <div className="col-12">
                  <div className="aadhar_info_Card">
                    <ul>
                      <li>
                        <span>Name:</span> {aadharinfo?.name || aadharinfo?.full_name || "-"}
                      </li>
                      <li>
                        <span>Date of Birth:</span> {aadharinfo?.dob || "-"}
                      </li>
                    </ul>
                  </div>
                </div>
                <div className="col-12 mt-4">
                  <button
                    type="button"
                    className="btn btn-primary w-100 py-3 mb-3"
                    disabled={isAadharDisabled}
                    onClick={(...args) => handleAadharSubmit(...args)}
                  >
                    Submit
                  </button>
                  <button
                    type="button"
                    className="btn text-primary w-100 py-3"
                    onClick={(e) => closeAadharModal()}
                  >
                    Cancel
                  </button>
                </div>
              </>
            )}
          </div>
        </Modal.Body>
      </Modal>

      {/* RECHARGE MODAL */}
      <Modal
        show={showrechargemodal}
        onHide={closeRechargeModal}
        centered
        backdrop="static"
        className="consent_otp_modal"
      >
        <Modal.Header
          closeButton
          className="border-0 py-4 d-flex align-item-start"
        >
          <h2>Recharge</h2>
        </Modal.Header>
        <Modal.Body className="pt-0">
          <div className="row g-3 mb-4">
            <AppForm onSubmit={handleRechargeSubmit}>
              <AppInput type="email" name="email" label="Email Address" />
              <AppInput type="number" name="phone" label="Phone Number" />
              <AppInput
                type="select"
                name="amount"
                label="Recharge Amount"
                options={_enum.RECHARGE_AMOUNTS}
                onChange={(...args) => handleRechargeAmount(...args)}
                required={true}
              />
              {showCustomAmountInput && (
                <AppInput
                  type="number"
                  name="custom_amount"
                  label="Enter Amount"
                  required={true}
                />
              )}
              <div
                className={Object.className({
                  "col-12 mt-3": true,
                })}
              >
                <button
                  type="submit"
                  className="btn btn-primary w-100 py-3 mb-3"
                >
                  Payment Checkout
                </button>
                <button
                  type="button"
                  className="btn text-primary w-100 py-3"
                  onClick={(e) => closeRechargeModal()}
                >
                  Cancel
                </button>
              </div>
            </AppForm>
          </div>
        </Modal.Body>
      </Modal>

      {/* TRANSACTION MODAL */}
      <Modal
        show={showtransmodal}
        onHide={closeTransModal}
        centered
        backdrop="static"
        className="consent_otp_modal modal-lg"
        size="xl"
      >
        <Modal.Header
          closeButton
          className="border-0 py-4 d-flex align-item-start"
        >
          <h2>Transaction Details</h2>
        </Modal.Header>
        <Modal.Body className="pt-0">
          <Tab.Container>
            <Card
              name="custom-tab"
              className="dz-card min-h-[600px] border-0 shadow-none"
            >
              <Tab.Content>
                <Card.Body>
                  {/* <!-- Nav tabs --> */}
                  <div className="custom-tab-1">
                    <Tab.Container
                      defaultActiveKey={activeKey}
                      activeKey={activeKey}
                      onSelect={handleSelect}
                    >
                      <Nav as="ul" className="nav-tabs">
                        {tabData.map((data, i) => (
                          <Nav.Item as="li" key={i}>
                            <Nav.Link eventKey={data.key}>{data.name}</Nav.Link>
                          </Nav.Item>
                        ))}
                      </Nav>
                      <Tab.Content className="pt-4">
                        {activeKey === "this-month" && (
                          <Tab.Pane eventKey="this-month">
                            <TransactionTable keyvalue="this-month" />
                          </Tab.Pane>
                        )}

                        {activeKey === "last-three-months" && (
                          <Tab.Pane eventKey="last-three-months">
                            <TransactionTable keyvalue="last-three-months" />
                          </Tab.Pane>
                        )}

                        {activeKey === "last-six-months" && (
                          <Tab.Pane eventKey="last-six-months">
                            <TransactionTable keyvalue="last-six-months" />
                          </Tab.Pane>
                        )}

                        {activeKey === "custom" && (
                          <Tab.Pane eventKey="custom">
                            <TransactionTable keyvalue="custom" />
                          </Tab.Pane>
                        )}
                      </Tab.Content>
                    </Tab.Container>
                  </div>
                </Card.Body>
              </Tab.Content>
            </Card>
          </Tab.Container>
          <div className="row g-3 mb-4">
            <div
              className={Object.className({
                "col-12 mt-3 text-end": true,
              })}
            >
              <button
                type="button"
                className="btn btn-sm btn-primary py-3 px-5 fs-3"
                onClick={(e) => closeTransModal(e)}
              >
                Close
              </button>
            </div>
          </div>
        </Modal.Body>
      </Modal>
    </>
  );
};

export default constore(kyc);
